import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzTdAddOnComponent } from "ng-zorro-antd/table";

@Component({
  selector: "td[uiChecked], td[uiDisabled], td[uiIndeterminate], td[uiIndentSize], td[uiExpand], td[uiShowExpand], td[uiShowCheckbox]",
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  templateUrl: "td-addon.component.html",
})
export class UiTdAddOnComponent extends NzTdAddOnComponent {
  @Input("uiChecked") public nzChecked = false;
  @Input("uiDisabled") public nzDisabled = false;
  @Input("uiIndeterminate") public nzIndeterminate = false;
  @Input("uiIndentSize") public nzIndentSize = 0;
  @Input("uiShowExpand") @InputBoolean() public nzShowExpand = false;
  @Input("uiShowCheckbox") @InputBoolean() public nzShowCheckbox = false;
  @Input("uiExpand") @InputBoolean() public nzExpand = false;
  @Output("uiCheckedChange") public readonly nzCheckedChange = new EventEmitter<boolean>();
  @Output("uiExpandChange") public readonly nzExpandChange = new EventEmitter<boolean>();
}
